import { render } from "./annualLoss.vue?vue&type=template&id=3ae7bb77&scoped=true"
import script from "./annualLoss.vue?vue&type=script&lang=js"
export * from "./annualLoss.vue?vue&type=script&lang=js"

import "./annualLoss.vue?vue&type=style&index=0&id=3ae7bb77&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae7bb77"]])

export default __exports__